import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { ENABLE_KLEOS_ROLES } from '~/services/environment/environment';
import { checkAuth } from '~/shared/auth/auth-utils';
import { userQuery } from '~/shared/api/user.queries';
import { myGlobalPermissionsQuery } from '~/shared/api/myGlobalPermissions.queries';

export const appContentLoader =
  (queryClient: QueryClient) =>
  async ({ request }: LoaderFunctionArgs) => {
    await checkAuth(request);

    await Promise.all([
      queryClient.ensureQueryData(userQuery()),
      ...(ENABLE_KLEOS_ROLES
        ? [queryClient.ensureQueryData(myGlobalPermissionsQuery())]
        : []),
    ]);

    return null;
  };
